import { useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'

export function useIsRecommendedPriceEnabled() {
  return useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.recommendedPriceEnabled === true
  )
}
